module.exports = __webpack_public_path__ + "static/media/20180905_105559.7992221b.jpg";